import React from "react";
import ReactFlow, { Background, Edge, Node } from "reactflow";
import "reactflow/dist/style.css";
import "./ReactFlow.scss";
import { NodeTypesEnum } from "./enum/Nodeflow.enum";
import AgentNode from "./CustomNodes/AgentNode/AgentNode";

interface SharedFlowProps {
  nodeProps: {
    nodes: Node[];
    edges: Edge[];
  };
  maxZoom: number;
  handleChangedNodes?: any;
}

const nodeTypes = {
  [NodeTypesEnum.AgentNode]: AgentNode,
};

const SharedFlow: React.FC<SharedFlowProps> = ({
  nodeProps,
  maxZoom,
  handleChangedNodes,
}) => {
  // const onNodesChange = (changes: NodeChange[]) => {
  //   if (
  //     changes &&
  //     changes.filter((nodeItem: any) => nodeItem.item).length > 0
  //   ) {
  //     handleChangedNodes(
  //       changes
  //         .filter((nodeItem: any) => nodeItem.item)
  //         .map((nodeItem: any) => {
  //           const item = nodeItem.item;
  //           return {
  //             id: item.id,
  //             type: NodeTypesEnum.AgentNode,
  //             position: item.position,
  //             data: item.data,
  //             className: "",
  //           };
  //         }),
  //       )}

  return (
    <ReactFlow
      nodeTypes={nodeTypes}
      nodes={nodeProps.nodes}
      edges={nodeProps.edges}
      maxZoom={maxZoom}
      fitView
    >
      <Background />
    </ReactFlow>
  );
};

export default SharedFlow;
